import { Injectable } from '@angular/core';
import { SvgIconName } from '@shared/svg-icon/svg-icon-name';
import { BehaviorSubject } from 'rxjs';

type TaskIndicatorName = "pdf-export" | "datasheet-export" | "cae-export" | "csv-export" | "printconverter-export";

@Injectable({
  providedIn: 'root'
})
export class BackgroundTasksInfoService {

  private _tasks =
    new BehaviorSubject(new Map<TaskIndicatorName, { icon: SvgIconName, tooltip: string, active: boolean }>([
      ["pdf-export", {icon: "documentation", tooltip: "main.docu.generating", active: false}],
      ["datasheet-export", {icon: "documentation", tooltip: "main.file.generating", active: false}],
      ["csv-export", {icon: "list", tooltip: "header.menu.generate_csv", active: false}],
      ["cae-export", {icon: "folder-import", tooltip: "main.file.generating", active: false}],
      ["printconverter-export", {icon: "documentation", tooltip: "main.file.generating", active: false}],
    ]));

  public tasks$ = this._tasks.asObservable();

  public isTaskActive(key: TaskIndicatorName) {
    return this._tasks.value.get(key)?.active;
  }

  public setTaskActive(key: TaskIndicatorName, active: boolean) {
    this._tasks.value.get(key)!.active = active;
    this._tasks.next(this._tasks.value);
  }

  public async doWithTaskIndicator<T>(taskName: TaskIndicatorName, asyncFunc: () => Promise<T>): Promise<T> {
    try {
      this.setTaskActive(taskName, true);
      return await asyncFunc();
    } finally {
      this.setTaskActive(taskName, false);
    }
  }
}
